import { PARSE_STATUS } from "./options/PARSE_STATUS";
import { CLIENT_TEMPLATE } from "./options/CLIENT_TEMPLATE";
import { SYSTEM_STATUS } from "./options/SYSTEM_STATUS";
import { DEFAULT_SERVICE } from "./options/DEFAULT_SERVICE";
import { DEBT_COLLECTION_STATUS } from "./options/DEBT_COLLECTION_STATUS";
import { SUB_STATUS } from "./options/SUB_STATUS";
import { FILE_STATUS } from "./options/FILE_STATUS";

export const getParseStatusLabelById = (parseStatusId) => {
  const parseStatusObj = PARSE_STATUS.find((el) => el.id == parseStatusId);

  if (parseStatusObj) {
    return parseStatusObj.label;
  } else {
    return "";
  }
};
export const getClientTemplateLabelById = (templateId) => {
  const templateObj = CLIENT_TEMPLATE.find((el) => el.Value == templateId);

  if (templateObj) {
    return templateObj.Name;
  } else {
    return "";
  }
};

export const getSystemStatusLabelById = (systemStatusID) => {
  const systemStatusObj = SYSTEM_STATUS.find((el) => el.id == systemStatusID);
  if (systemStatusObj) {
    return systemStatusObj.label;
  } else {
    return "";
  }
};

export const getFileStatusLabelById = (fileId) => {
  const tmpFileId = fileId && fileId > 0 ? 0 : fileId;

  const fileStatus = FILE_STATUS.find((el) => el.id === tmpFileId);

  if (fileStatus) {
    return fileStatus.label;
  } else {
    return "";
  }
};

export const getSubStatusLabelById = (subStatusID) => {
  const subStatusObj = SUB_STATUS.find((el) => el.id == subStatusID);
  if (subStatusObj) {
    return subStatusObj.label;
  } else {
    return "";
  }
};

export const getDebtCollectionStatusLabelById = (debtCollectionId) => {
  const systemStatusObj = DEBT_COLLECTION_STATUS.find(
    (el) => el.id == debtCollectionId
  );

  if (systemStatusObj) {
    return systemStatusObj.label;
  } else {
    return "";
  }
};

export const getDefaultServiceLabelById = (defaultServiceId) => {
  const serviceObj = DEFAULT_SERVICE.find((el) => el.id == defaultServiceId);

  if (serviceObj) {
    return serviceObj.Name;
  } else {
    return "";
  }
};

export const getInvoiceTypeChip = (type) => {
  let color = "";
  let label = "";
  switch (type) {
    case "Credit":
      color = "#d32f2f";
      label = "Kredit";
      break;
    case "Räntefaktura":
      color = "gray";
      label = "Räntefaktura";
      break;
    case "Påminnelse":
      color = "gray";
      label = "Påminnelse";
      break;
    default:
      color = "gray";
      label = "Faktura";
      break;
  }
  return { label, color };
  //return <Chip label={label} sx={{ background: color, color: "white" }} />;
};
